/* ************************ *
* Initialise the branch map *
* ************************* */
function initBranchMap () {

    var latLng = new google.maps.LatLng(55.3617609, -3.4433238); // Default LatLng (UK)
    var zoom = 5; // Default zoom

    $('[id^=branch]').each(function () {
        var latitude = $(this).data("latitude");
        var longitude = $(this).data("longitude");

        if (typeof latitude !== "undefined" && typeof longitude !== "undefined") {
            latLng = new google.maps.LatLng(latitude, longitude);
            zoom = 15;
        }

        var styles = [
            {
                stylers: [
                    { hue: '#c22236' }
                ]
            }, {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [
                    { lightness: 100 },
                    { visibility: 'simplified' }
                ]
            }
        ];

        var mapOptions = {
            center: latLng,
            zoom: zoom,
            styles: styles
        };

        var map = new google.maps.Map(this, mapOptions);

        var marker = new google.maps.Marker({
            map: map,
            position: latLng,
            animation: google.maps.Animation.DROP,
            title: $(this).data("branch-header")
        });
    });

    google.maps.event.addDomListener(window, 'load', initBranchMap);
}